import { render, staticRenderFns } from "./text-bg.vue?vue&type=template&id=dca997a0&scoped=true"
import script from "./text-bg.vue?vue&type=script&lang=js"
export * from "./text-bg.vue?vue&type=script&lang=js"
import style0 from "./text-bg.vue?vue&type=style&index=0&id=dca997a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca997a0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/product/exam/text-bg.vue
// module id = null
// module chunks = 